if(navigator.userAgent.indexOf("Firefox") != -1 ){
	$('.bottom-bar span:not([class])').css('font-family', "B612 Mono");
} 
